// extracted by mini-css-extract-plugin
export default {"tariffs-catalog":"TLUer","tariffs-catalog__title":"frq7a","discount":"eWkcv","sub-title-text":"Zv7fu","show-tariffs-button-wrapper":"cagVq","preloader":"Gb3FS"};